import {spawnErrorToast} from '@hm/fundamental'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {useRefraQuery} from '@refra/modules/common/hooks'
import {ErrorResponse} from '@refra/modules/common/types'
import {logger} from '@refra/modules/common/utils'

interface useShutdownsQueryParams {
  plantUpmId: string
  kilnUpmId: string
  shutdownId: number
}

export const useKilnShutdownReportQuery = ({
  plantUpmId,
  kilnUpmId,
  shutdownId
}: useShutdownsQueryParams) => {
  const {t} = useTranslation()

  return useRefraQuery({
    queryKey: 'shutdownReport',
    params: [{plantUpmId, kilnUpmId, shutdownId}],
    throwOnError: (error) => {
      const axiosError = error as AxiosError<ErrorResponse>
      const errorDetails =
        axiosError?.response?.data.detail ?? axiosError.message ?? axiosError.response?.status
      logger
        .context('useKilnShutdownReportQuery')
        .extras({errorDetails, plantUpmId, kilnUpmId})
        .error('Error occurred while fetching shutdown report')

      spawnErrorToast(t('error.generateReport'))

      return false
    }
  })
}
